"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _Dimensions = _interopRequireDefault(require("FileManagerLib/components/Dimensions"));

var _spacing = require("../constants/spacing");

var _requiredBy = _interopRequireDefault(require("../utils/requiredBy"));

var _AlignmentList = _interopRequireDefault(require("./AlignmentList"));

var _Margin = _interopRequireDefault(require("./Margin"));

var _toolbar = require("../constants/toolbar");

var StyleControls = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(StyleControls, _React$Component);

  function StyleControls() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, StyleControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(StyleControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleDimensionsChange = function (dimensions) {
      clearTimeout(_this._debounceDimensionsTimeout);
      _this._debounceDimensionsTimeout = setTimeout(function () {
        _this.props.onDimensionsChange(dimensions);
      }, _toolbar.DEBOUNCE_TIMEOUT);
    };

    _this.handleDimensionsStep = function (dimensions) {
      clearTimeout(_this._debounceDimensionsTimeout);

      _this.props.onDimensionsChange(dimensions);
    };

    return _this;
  }

  (0, _createClass2.default)(StyleControls, [{
    key: "renderDimensions",
    value: function renderDimensions() {
      var _this$props = this.props,
          dimensions = _this$props.dimensions,
          maxDimensions = _this$props.maxDimensions,
          naturalHeight = _this$props.naturalHeight,
          naturalWidth = _this$props.naturalWidth,
          showDimensionsControls = _this$props.showDimensionsControls;

      if (!showDimensionsControls) {
        return null;
      }

      return _react.default.createElement(_Dimensions.default, {
        dimensions: dimensions,
        naturalHeight: naturalHeight,
        naturalWidth: naturalWidth,
        onChange: this.handleDimensionsChange,
        onStep: this.handleDimensionsStep,
        widthStepperProps: {
          min: 0,
          max: maxDimensions.width,
          styled: true,
          placeholderValue: 0
        },
        heightStepperProps: {
          min: 0,
          max: maxDimensions.height,
          styled: true,
          placeholderValue: 0
        }
      });
    }
  }, {
    key: "renderAlignments",
    value: function renderAlignments() {
      var _this$props2 = this.props,
          alignment = _this$props2.alignment,
          onChangeAlignment = _this$props2.onChangeAlignment,
          i18nAlignmentKey = _this$props2.i18nAlignmentKey,
          showAlignmentControls = _this$props2.showAlignmentControls,
          showInlineAlignment = _this$props2.showInlineAlignment;

      if (!showAlignmentControls) {
        return null;
      }

      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nAlignmentKey('label')),
        className: "m-y-2"
      }, _react.default.createElement(_AlignmentList.default, {
        i18nAlignmentKey: i18nAlignmentKey,
        alignment: alignment,
        onChangeAlignment: onChangeAlignment,
        showInlineAlignment: showInlineAlignment
      }));
    }
  }, {
    key: "renderMargins",
    value: function renderMargins() {
      var _this$props3 = this.props,
          margin = _this$props3.margin,
          onMarginChange = _this$props3.onMarginChange,
          showMarginControls = _this$props3.showMarginControls,
          spacingIconType = _this$props3.spacingIconType,
          staticPrefix = _this$props3.staticPrefix;

      if (!showMarginControls) {
        return null;
      }

      return _react.default.createElement(_Margin.default, {
        margin: margin,
        onMarginChange: onMarginChange,
        staticPrefix: staticPrefix,
        spacingIconType: spacingIconType
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, this.renderDimensions(), this.renderAlignments(), this.renderMargins());
    }
  }]);
  return StyleControls;
}(_react.default.Component);

exports.default = StyleControls;
StyleControls.propTypes = {
  i18nAlignmentKey: (0, _requiredBy.default)('showAlignmentControls', _propTypes.default.func),
  dimensions: (0, _requiredBy.default)('showDimensionsControls', _propTypes.default.shape({
    height: _propTypes.default.number.isRequired,
    width: _propTypes.default.number.isRequired
  })),
  maxDimensions: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number
  }),
  onDimensionsChange: (0, _requiredBy.default)('showDimensionsControls', _propTypes.default.func),
  naturalHeight: _propTypes.default.number,
  naturalWidth: _propTypes.default.number,
  margin: (0, _requiredBy.default)('showMarginControls', _propTypes.default.object),
  onMarginChange: (0, _requiredBy.default)('showMarginControls', _propTypes.default.func),
  alignment: (0, _requiredBy.default)('showAlignmentControls', _propTypes.default.string),
  onChangeAlignment: (0, _requiredBy.default)('showAlignmentControls', _propTypes.default.func),
  staticPrefix: _propTypes.default.string.isRequired,
  spacingIconType: _propTypes.default.oneOf(Object.values(_spacing.SpacingIconTypes)),
  showDimensionsControls: _propTypes.default.bool,
  showMarginControls: _propTypes.default.bool,
  showAlignmentControls: _propTypes.default.bool,
  showInlineAlignment: _propTypes.default.bool
};
StyleControls.defaultProps = {
  showDimensionsControls: true,
  showMarginControls: true,
  showAlignmentControls: true,
  maxDimensions: {}
};
module.exports = exports.default;